import React from 'react';
import { useFormikContext } from 'formik';
import { observer } from 'mobx-react';
import { Grid } from '@material-ui/core';

import useSession from 'core/hooks/use-session';
import { Label } from 'core/components/label';
import { Button } from 'core/components/button';
import { withToast } from 'core/components/toast';
import { useStore } from 'core/store/store.mobx';
import { Tooltip } from 'core/components/tooltip';
import LockIcon from 'core/assets/svg/ic-locked.svg';
import pencilIcon from 'core/assets/svg/pencil-orange.svg';
import viewIcon from 'core/assets/svg/view.svg';
import { Loading } from 'core/components/loading';
import useStyles from '../footer.styles';
import { ConfirmCheckout } from '../../checkout';

const checkoutButtonLabel = 'Continue to Checkout';

const Checkout = observer(({ showValidationErrorsModal, onCheckout, copyLink, hasInvalidVins, loading }) => {
  const { offer: store } = useStore();
  const classes = useStyles();
  const { validateForm } = useFormikContext();
  const buttonLabelValue = hasInvalidVins ? 'Validate VIN(s)' : checkoutButtonLabel;
  const session = useSession();
  const licensedToCheckout = store.getIsLicensedForState(session) && buttonLabelValue === checkoutButtonLabel;

  const handleCopyCustomQuoteClick = () => {
    const readOnly = false;
    copyLink(readOnly);
  };

  const handleCopyReadOnlyQuoteClick = () => {
    const readOnly = true;
    copyLink(readOnly);
  };

  return (
    <>
      <div>
        <Label className={classes.title} type="subtitle">
          Your Offer is Ready
        </Label>
        {!store.softRejectionOnOffer && licensedToCheckout ? (
          <div className={classes.copyLinksContainer}>
            <Label type="infoValue">Share link:</Label>
            <Button color="secondary" variant="text" onClick={handleCopyCustomQuoteClick}>
              <img src={pencilIcon} alt="Orange pencil icon" className={classes.copyLinkIcons} />
              Customizable offer
            </Button>
            <Button color="secondary" variant="text" onClick={handleCopyReadOnlyQuoteClick}>
              {loading ? (
                <Loading type="secondary" noBackground size={20} className={classes.copyLinkIcons} />
              ) : (
                <img src={viewIcon} alt="View icon" className={classes.copyLinkIcons} />
              )}
              Non-editable offer
            </Button>
          </div>
        ) : (
          <div className={classes.tooltipContainer}>
            <Label type="infoValue">Share link:</Label>
            <div className={classes.tooltip}>
              <img src={pencilIcon} alt="Orange pencil icon" className={classes.copyLinkIcons} />
              <Tooltip
                text={
                  store.softRejectionOnOffer
                    ? 'The current offer link cannot be shared because it has rejections. See the offer rejections section for more information.'
                    : 'You must be licensed in this state to copy the offer link.'
                }
                placement="top"
                label="Customizable offer"
                className={classes.tooltipText}
              />
              <img src={LockIcon} alt="Lock Icon" />
            </div>
            <div className={classes.tooltip}>
              <img src={viewIcon} alt="View icon" className={classes.copyLinkIcons} />
              <Tooltip
                text={
                  store.softRejectionOnOffer
                    ? 'The current offer link cannot be shared because it has rejections. See the offer rejections section for more information.'
                    : 'You must be licensed in this state to copy the offer link.'
                }
                placement="top"
                label="Non-editable offer"
                className={classes.tooltipText}
              />
              <img src={LockIcon} alt="Lock Icon" />
            </div>
          </div>
        )}
      </div>
      <ConfirmCheckout
        onCheckout={onCheckout}
        showValidationModal={showValidationErrorsModal}
        validateCheckout={validateForm}
        CheckOutAction={({ onClick }) => (
          <Grid container alignItems="center" justifyContent="center">
            <Button
              variant="contained"
              color="primary"
              className={classes.btn}
              disabled={store.loading || (!hasInvalidVins && !licensedToCheckout)}
              onClick={onClick}
            >
              <Label className={classes.btnLabel}>{buttonLabelValue}</Label>
            </Button>
            {!licensedToCheckout && (
              <Tooltip text="You must be licensed in this state to bind this policy" placement="top" />
            )}
          </Grid>
        )}
      />
    </>
  );
});
export default withToast(Checkout);
